module.exports = __webpack_public_path__ + "static/media/challenges-phone.70c2eb70.png";